import { SimpleTreeView } from '@mui/x-tree-view';
import {
  Box,
  FormControl,
  formLabelClasses,
  inputLabelClasses,
  outlinedInputClasses,
  Select,
  styled,
  textFieldClasses,
} from '@mui/material';
import { treeItemClasses } from '@mui/x-tree-view';

export const HBSelectTreeFormControlStyle = styled(FormControl)(({ theme }) => ({
  minWidth: 160,
  [`& .${formLabelClasses.asterisk}`]: {
    fontFamily: 'arial',
  },
  [`& .${outlinedInputClasses.root}`]: {
    borderRadius: 8,
  },
  [`& fieldset.${outlinedInputClasses.notchedOutline}`]: {
    borderColor: theme.palette.grey[300],
  },
  [`& .${outlinedInputClasses.root} `]: {
    [`&.${outlinedInputClasses.focused} .${outlinedInputClasses.notchedOutline}`]: {
      borderColor: theme.palette.grey[300],
      borderWidth: 1,
    },
    [`&.${outlinedInputClasses.root} .${outlinedInputClasses.notchedOutline}`]: {
      textAlign: 'initial',
    },
    [`&:hover .${outlinedInputClasses.notchedOutline}`]: {
      borderColor: theme.palette.primary.main,
    },
  },
  [`& .${formLabelClasses.root}.${inputLabelClasses.focused}`]: {
    color: theme.palette.primary.main,
  },
  [`& .${formLabelClasses.root}.${inputLabelClasses.shrink}`]: {
    transformOrigin: 'top left',
  },
})) as typeof FormControl;

export const HBSelectTreeRootStyle = styled(Select)(({}) => {
  return {};
});

export const HBSelectTreeSearchStyle = styled(Box)(({ theme: { palette, spacing } }) => {
  return {
    padding: `${spacing(2)} ${spacing(4)}`,
    backgroundColor: palette.grey[200],
    borderRadius: spacing(2, 2, 0, 0),
    marginBottom: spacing(5),
    [`& .${textFieldClasses.root}`]: {
      backgroundColor: palette.common.white,
    },
  };
});
export const HBSelectTreeViewStyle = styled(SimpleTreeView)(({ theme: { spacing } }) => {
  return {
    height: 392,

    maxWidth: 400,
    flexGrow: 1,
    padding: spacing(0, 4),
    [`& .${treeItemClasses.label}`]: {
      padding: spacing(2, 0),
    },
    [`& .${treeItemClasses.content}`]: {
      margin: 0,
      padding: 0,
    },
    [`& .${treeItemClasses.iconContainer}`]: {
      width: 'fit-content',
    },
  };
});
